
export function initializeFilterScripts() {

  const loadMoreStep = 4;
  let count = 4,
    $loadMore = $('#loadMore'),
    $showAllItems = $('#showAllItems, #mobileShowAllItems'),
    $disableBtns = $('#mobileFilterByCategory, #closeFilter'),
    numItems = $('.category-grid .filter-item').length,
    $filterBtn = $('.categories button'),
    $gridItems = $('.category-grid .filter-item');


  /* FAQ Functions */
  function scrollToFAQ(faqId) {
    const button = '#btn-faq-'.concat(faqId)

    let faqTarget = $(button)

    if (faqTarget.length > 0) {
      faqTarget.trigger('click').focus();

      $('html, body').animate({
        scrollTop: faqTarget.offset().top
      }, 500, function () {
        $('html, body').scrollTop(faqTarget.offset().top) // Set offset on complete to account for other collapses changing the offset
      });
    }
  }

  function getQueryStringValue(key) {
    const url = new URL(window.location.href)

    if (url.searchParams.has(key)) {
      return url.searchParams.get(key)
    }

    return '';
  }

  function ifFAQCategoryIdParam() {
    let categoryId = getQueryStringValue('categoryid');

    if (categoryId !== '') {
      toggleFilterButton($('button[data-category="' + categoryId + '"]').get(0)); //Doing it to the first one, will toggle the others automatically.
    }
  }

  function ifFAQIdParam() {
    let faqId = getQueryStringValue('faqid');

    if (faqId !== '') {
      scrollToFAQ(faqId);
    }
  }

  /* FAQ Functions End */

  /* FAQ Events */


  // featured faqs: scroll to on click
  $('.scroll-to-faq a').on('click', function (e) {

    let faqTarget = $('.accordionFAQ');
    if (faqTarget.length > 0) {
      e.preventDefault();

      let faqTriggerID = $(this).data('document-id');

      scrollToFAQ(faqTriggerID);
    }

  });

  /* FAQ Events End */


  /* Articles Functions */

  function ifArticleInitialCategorySelection() {
    let selectedButtons = $('.categories button[aria-pressed="true"]');
    if (selectedButtons.length > 0) {
      addCssClass($gridItems, 'd-none');

      updateGridItems();
    }
  }

  // function: load more articles by `count`
  function initItems(count) {
    let articlesExists = $('.article-listing').length > 0;

    if (articlesExists) {
      addCssClass($gridItems, 'd-none');
      $gridItems.slice(0, count).removeClass('d-none');
      updateAlertMessage(numItems);
      updateLoadMoreVisibility();
    }
  }

  /* Articles Functions End */
  /* Articles Events */

  // load more: articles
  $($loadMore).on('click', function (e) {
    e.preventDefault();

    count = count + ((loadMoreStep <= numItems) ? (count + loadMoreStep) : numItems);

    $gridItems.slice(0, count).removeClass('d-none');

    updateAlertMessage(numItems);
    updateLoadMoreVisibility();
  });

  /* Articles Events End */

  /* Shared Functions */

  function toggleFilterButton(filterButton) {
    var filterButtons = $filterBtn.filter('[data-category="' + $(filterButton).data('category') + '"]');
    $(filterButtons).toggleClass('btn-yellow');
    addCssClass($gridItems, 'd-none');
    toggleARIAPressedState($(filterButtons));

    updateGridItems();
  }

  function updateGridItems() {
    // get selected categories
    let activeBtn = $('[aria-pressed="true"]');
    let categoriesSelected = activeBtn.map(function () {
      let btnCategory = $(this).data('category').toString();

      return btnCategory;
    }).get();

    if (categoriesSelected.length > 0) {
      // filter items if any categories are selected

      $gridItems.each(function (i, v) {
        let values = $(v).data('categories').toString().split(';');
        if (values.some(r => categoriesSelected.includes(r))) {
          $(v).removeClass('d-none');
        } else {
          $(v).addClass('d-none');
        }
      });

      updateAlertMessage(numItems);
      removeCssClass($showAllItems, 'd-none');
      // Always hide load more when category filter is applied (these behaviors are mutually exclusive)
      addCssClass($loadMore, 'd-none');
    } else {
      // reset if no categories are selected
      resetAll();
    }
  }

  function resetAll() {
    let articlesExists = $('.article-listing').length > 0;

    if (articlesExists) {
      // inital count, show 'load more'
      count = loadMoreStep;
      initItems(count);
    } else {
      // load all
      removeCssClass($gridItems, 'd-none');
    }

    addCssClass($showAllItems, 'd-none');
    updateAlertMessage(numItems);
    updateLoadMoreVisibility();

    $.each($filterBtn, function () {
      $(this).removeAttr('aria-pressed').removeClass('btn-yellow');
    });
  }

  // Sets load more button visibility based on whether there are more items to show
  function updateLoadMoreVisibility() {
    let hiddenItemCount = $('.category-grid .d-none').length;
    if (hiddenItemCount > 0) {
      removeCssClass($loadMore, 'd-none');
    } else {
      addCssClass($loadMore, 'd-none');
    }
  }

  // function: aria pressed state
  function toggleARIAPressedState(btnClicked) {
    let ariaPressedState = $(btnClicked).attr('aria-pressed');

    if (ariaPressedState === undefined) {
      $(btnClicked).attr('aria-pressed', true);
    } else {
      $(btnClicked).attr('aria-pressed', ariaPressedState === 'true' ? 'false' : 'true');
    }
  }

  function addCssClass(el, property) {
    $(el).addClass(property);
  }

  function removeCssClass(el, property) {
    $(el).removeClass(property);
  }

  function updateAlertMessage(numItems) {
    let currentCount = $('.category-grid .filter-item:visible').length;
    $('#listChangeAnnouncement').text('Currently displaying ' + currentCount + ' of ' + numItems + ' items.');
  }

  /* Shared Functions End */

  /* Shared Events */

  // reset
  $($showAllItems).on('click', function (e) {
    e.preventDefault();
    resetAll();
  });

  // category filter buttons
  $('.categories button').on('click', function (e) {
    e.preventDefault();

    toggleFilterButton(this);
  });

  $($disableBtns).on('click', function (e) {
    e.preventDefault();
  });

  /* Shared Events End */

  /* Load */
  function load() {
    addCssClass($showAllItems, 'd-none');
    initItems(count, numItems);
    ifFAQCategoryIdParam();
    ifFAQIdParam();
    ifArticleInitialCategorySelection();
  }

  /* load */
  load();
}


document.addEventListener('DOMContentLoaded', (event) => {
  initializeFilterScripts()
})
